import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Button } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import {
  StepContentContainer,
  ModalTitle,
  BreakInfoText,
  WarningContainer,
  WarningText,
  ButtonContainer,
} from '../BreakOptionsModal.styles';

const StartBreakConfirmationStep = ({ isLoading, onStartBreakSubmit, onCancel }) => {
  return (
    <StepContentContainer>
      <ModalTitle variant="h6" component="h2">
        Start Break Confirmation
      </ModalTitle>

      <BreakInfoText variant="body1">You are about to start your meal break.</BreakInfoText>

      <WarningContainer>
        <WarningIcon color="warning" />
        <WarningText>
          <strong>Warning: </strong>
          If you start this meal break now, you will miss your rest break deadline. Consider taking a rest break first.
        </WarningText>
      </WarningContainer>

      <ButtonContainer>
        <Button variant="primary" onClick={onStartBreakSubmit} disabled={isLoading}>
          {isLoading ? <CircularProgress color="inherit" size={16} /> : 'Start Break Anyway'}
        </Button>
        <Button variant="primaryDestructive" onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
      </ButtonContainer>
    </StepContentContainer>
  );
};

StartBreakConfirmationStep.propTypes = {
  isLoading: PropTypes.bool,
  onStartBreakSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default StartBreakConfirmationStep;
